import type { InferOutput } from "valibot";

// 'ask lower price' form schema
export const askLowerPriceSchema = v.object({
  product_id: v.number(),
  email: v.pipe(v.string(), v.email()),
  name: v.string(),
  description: v.string(),
  price: v.number(),
});
export type AskLowerPrice = InferOutput<typeof askLowerPriceSchema>;
